import React, { useMemo } from "react";
import { ArrowRightIcon, CheckIcon, CreditCardIcon, FileTextIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { ProductMockup } from "./ProductMockup";
import { offerIncludes } from "../data/landing";
import { productBrief } from "../data/productBrief";
import { getCheckoutUrl } from "../utils/checkout";
export function OfferSection() {
  const checkoutUrl = useMemo(() => getCheckoutUrl(), []);
  const openLicenseFaq = () => {
    const item = document.getElementById("faq-license");
    if (item instanceof HTMLDetailsElement) item.open = true;
  };
  return <section className="section offer-section" id="offer-details" aria-labelledby="offer-heading" data-id="element-69" data-mp="rdmwbmovc7vq">
      <div className="shell" data-id="element-70" data-mp="wby9o7edh0ip">
        <div className="section-intro" data-id="element-71" data-mp="wc80fx78rbpg">
          <p className="eyebrow" data-id="element-72" data-mp="2t5jbd6a8vzv9">THE PLANNING IS ALREADY DONE</p>
          <h2 id="offer-heading" data-id="element-73" data-mp="2t7dwaklinrzc">
            Your next team communication workshops.
            <br data-id="element-74" data-mp="2y4w4u9vmg56t" />
            <span data-id="element-75" data-mp="2y6gsdfjiqnv6">Already planned for you.</span>
          </h2>
        </div>
        <div className="offer-grid" data-id="element-76" data-mp="12p35136g1gnn">
          <div className="offer-contents" data-id="element-77" data-mp="xws6o4rcq2x7">
            <p className="eyebrow" data-id="element-78" data-mp="xvqs3qb4myaq">VOLUME 1 · EVERYDAY TEAM COMMUNICATION</p>
            <h3 data-id="element-79" data-mp="sx78hwk09ylj">{productBrief.brand}</h3>
            <p data-id="element-80" data-mp="sy8mo9wbj17h">
              The agendas, facilitator wording, role cards, examples and feedback sheets are already
              written. You get Volume 1 with five complete workshop plans, printable participant
              materials and five bonuses to organize the practice around them.
            </p>
            <h4 data-id="element-81" data-mp="1go2yco4wijq5">Your ready-to-run training plan includes</h4>
            <ul className="check-list" data-id="element-82" data-mp="1ckn0joh3idbv">
              {offerIncludes.map(item => <li key={item} data-id="element-83" data-mp="17n4se0awk24x">
                  <CheckIcon size={18} aria-hidden="true" data-id="element-84" data-mp="17m3cniixyrgv" />
                  {item}
                </li>)}
            </ul>
            <h4 data-id="element-85" data-mp="3scu2y14kp1rt">All five bonuses are included</h4>
            <ul className="bonus-checks" data-id="element-86" data-mp="3sc155pnldmlt">
              {productBrief.bonuses.map(bonus => <li key={bonus.number} data-id="element-87" data-mp="3tvavi7nkrkes">
                  <CheckIcon size={16} aria-hidden="true" data-id="element-88" data-mp="3ts6kaqbozoem" />
                  {bonus.title}
                </li>)}
            </ul>
          </div>

          <div className="price-card" data-id="element-89" data-mp="3ksjii3f1wgl1">
            <ProductMockup data-id="element-90" data-mp="3kvnqzczjtyhi" />
            <p className="price-caption" data-id="element-91" data-mp="3ouddbv2keqda">VOLUME 1 · 5 WORKSHOPS + 5 BONUSES</p>
            <p className="offer-price" data-id="element-92" data-mp="3b3i4gis2g99p">
              <span data-id="element-93" data-mp="3b2goq103uyln">${productBrief.price.amountUsd}</span> USD
            </p>
            <p className="payment-note" data-id="element-94" data-mp="3fuqdhdphhsmc">One-time payment. No subscription.</p>
            <CtaButton href={checkoutUrl} data-id="element-95" data-mp="315c3c3e3375w">
              Get my complete training plan <ArrowRightIcon size={18} aria-hidden="true" data-id="element-96" data-mp="31756v9tehb9o" />
            </CtaButton>
            <div className="delivery-details" data-id="element-97" data-mp="364ydg3ym87ah">
              <p data-id="element-98" data-mp="2s4w10x92u62m">
                <CreditCardIcon size={17} aria-hidden="true" data-id="element-99" data-mp="2s4du96osg9gg" />
                Continue to the Impul store checkout
              </p>
              <p data-id="element-100" data-mp="2x37cfcf0somy">
                <FileTextIcon size={17} aria-hidden="true" data-id="element-101" data-mp="2x5teiwj56bxs" />
                English PDFs + printable participant pages
              </p>
            </div>
            <p className="format-note" data-id="element-102" data-mp="28jvu0rc05uh6">
              {productBrief.status}
              <br data-id="element-103" data-mp="2mj4wypb76s37" />
              Internal-team use. No video, slides, editable templates, software, certification or
              resale rights.
            </p>
            <a className="license-link" href="#faq-license" onClick={openLicenseFaq} data-id="element-104" data-mp="2ij4jb6vxakx7">
              Read format and license FAQs
            </a>
          </div>
        </div>
      </div>
    </section>;
}